import React from 'react'
import { getAuth, sendEmailVerification } from 'firebase/auth'
import { bool } from 'prop-types'
import { useModalsContext } from '@context/modalContext'
import { Box, Stack, styled } from '@mui/material'
import { useNotifications } from '@context/notifications'

export const MODAL_ID = 'MODAL/EMAIL_VERIFICATION'

const ResendVerificationButton = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  marginLeft: '8px',
}))

const ResendWrapper = styled(Stack)(({ noTemplate }) => ({
  justifyContent: 'center',
  alignItems: noTemplate ? 'flex-start' : 'center',
  marginBottom: '32px',
}))

const DescriptionSpan = styled('div')(({ theme, noTemplate }) => ({
  textAlign: noTemplate ? 'left' : 'center',
  marginBottom: '8px',
  [theme.breakpoints.down('sm')]: {
    width: '85%',
  },
}))

const ContinueShoppingButton = styled('button')(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  fontWeight: '600',
  height: '37px',
  borderRadius: '5px',
  textTransform: 'uppercase',
  [theme.breakpoints.down('sm')]: {
    width: '85%',
  },
}))

export const EmailVerification = ({ noTemplate = false }) => {
  const { actions } = useModalsContext()
  const { enqueue } = useNotifications()
  const auth = getAuth()

  const sendVerificationEmail = currentUserAuth => {
    sendEmailVerification(currentUserAuth)
      .then(
        setTimeout(() => {
          enqueue({ variant: 'filled', body: 'Email verification sent!' })
        }, 500),
      )
      .catch(error => {
        const errorCode = error.code
        const errorMessage = error.message
        console.error(errorCode, errorMessage)
      })
  }
  return (
    <Box>
      <DescriptionSpan noTemplate={noTemplate}>
        We sent an email to <span style={{ fontWeight: 'bold' }}>{auth?.currentUser?.email}</span>. Click the link in
        the email to verify your email. You may need to check you spam folder.
      </DescriptionSpan>
      <Stack>
        <ResendWrapper noTemplate={noTemplate}>
          <span style={{ fontSize: '14px' }}>
            Didn't get the email?
            <ResendVerificationButton onClick={() => sendVerificationEmail(auth.currentUser)}>
              Resend Link
            </ResendVerificationButton>
          </span>
        </ResendWrapper>
        <ContinueShoppingButton onClick={actions.close}>Continue Shopping</ContinueShoppingButton>
      </Stack>
    </Box>
  )
}

EmailVerification.propTypes = {
  noTemplate: bool,
}
